// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"eab39a6faef0c673","9777":"4114b551dfca609c"}[chunkId] + ".js";
};